export default __webpack_public_path__ + "static/media/background.9608b855.png";